package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.SearchW500Rounded: ImageVector
    get() {
        if (_searchW500Rounded != null) {
            return _searchW500Rounded!!
        }
        _searchW500Rounded = Builder(name = "SearchW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(378.09f, 645.5f)
                quadToRelative(-111.16f, 0.0f, -188.33f, -77.17f)
                quadToRelative(-77.17f, -77.18f, -77.17f, -188.33f)
                reflectiveQuadToRelative(77.17f, -188.33f)
                quadToRelative(77.17f, -77.17f, 188.33f, -77.17f)
                quadToRelative(111.15f, 0.0f, 188.32f, 77.17f)
                quadToRelative(77.18f, 77.18f, 77.18f, 188.33f)
                quadToRelative(0.0f, 44.48f, -13.52f, 83.12f)
                quadToRelative(-13.53f, 38.64f, -36.57f, 68.16f)
                lineToRelative(222.09f, 222.33f)
                quadToRelative(12.67f, 12.91f, 12.67f, 31.94f)
                quadToRelative(0.0f, 19.04f, -12.91f, 31.71f)
                quadToRelative(-12.68f, 12.67f, -31.83f, 12.67f)
                reflectiveQuadToRelative(-31.82f, -12.67f)
                lineTo(529.85f, 595.41f)
                quadToRelative(-29.76f, 23.05f, -68.64f, 36.57f)
                quadToRelative(-38.88f, 13.52f, -83.12f, 13.52f)
                close()
                moveTo(378.09f, 554.5f)
                quadToRelative(72.84f, 0.0f, 123.67f, -50.83f)
                quadToRelative(50.83f, -50.82f, 50.83f, -123.67f)
                reflectiveQuadToRelative(-50.83f, -123.67f)
                quadToRelative(-50.83f, -50.83f, -123.67f, -50.83f)
                quadToRelative(-72.85f, 0.0f, -123.68f, 50.83f)
                quadToRelative(-50.82f, 50.82f, -50.82f, 123.67f)
                reflectiveQuadToRelative(50.82f, 123.67f)
                quadToRelative(50.83f, 50.83f, 123.68f, 50.83f)
                close()
            }
        }
        .build()
        return _searchW500Rounded!!
    }

private var _searchW500Rounded: ImageVector? = null
